<template>
  <transition name="loader-fade">
    <div v-if="loading" class="page-loader">
      <div class="loader-bg-grid"></div>
      <div class="loader-content">
        <!-- Glowing Ring / Scanline approach -->
        <div class="scan-ring">
          <div class="scan-line"></div>
        </div>
        
        <div class="text-container">
          <h1 class="brand-text">PORTOZ</h1>
          <p class="subtitle-text">{{ currentStepText }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'PageLoader',
  data() {
    return {
      loading: true,
      currentStepIndex: 0,
      steps: [
        "Initializing developer portfolio...",
        "Syncing CMS content...",
        "Preparing projects...",
        "Launching portfolio..."
      ],
      stepInterval: null
    };
  },
  computed: {
    currentStepText() {
      return this.steps[this.currentStepIndex];
    }
  },
  mounted() {
    // Rotate text steps rapidly
    this.stepInterval = setInterval(() => {
      if (this.currentStepIndex < this.steps.length - 1) {
        this.currentStepIndex++;
      }
    }, 300); // 300ms per step

    // Total duration: around 1200ms
    this.$nextTick(() => {
      setTimeout(() => {
        this.loading = false;
        clearInterval(this.stepInterval);
      }, 1200);
    });
  },
  beforeUnmount() {
    if (this.stepInterval) clearInterval(this.stepInterval);
  }
};
</script>

<style scoped>
.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #050816; /* Deep dark tech background */
  overflow: hidden;
}

/* Subtle Grid Background */
.loader-bg-grid {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(34, 211, 238, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(34, 211, 238, 0.04) 1px, transparent 1px);
  background-size: 30px 30px;
  background-position: center center;
  opacity: 0.5;
  z-index: 0;
}

.loader-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

/* Scan Ring Animation */
.scan-ring {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid rgba(34, 211, 238, 0.2);
  box-shadow: 0 0 20px rgba(34, 211, 238, 0.1);
  overflow: hidden;
}

.scan-line {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: rgba(34, 211, 238, 0.8);
  box-shadow: 0 0 10px rgba(34, 211, 238, 1);
  animation: scan 1.2s linear infinite;
}

@keyframes scan {
  0% { transform: translateY(-100%); }
  100% { transform: translateY(60px); }
}

.text-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.brand-text {
  margin: 0;
  font-family: var(--font-mono, monospace);
  font-size: 1.25rem;
  letter-spacing: 4px;
  color: #ffffff;
  text-transform: uppercase;
}

.subtitle-text {
  margin: 0;
  font-family: var(--font-mono, monospace);
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.5);
  min-height: 1.2rem; /* Keep height stable during text rotation */
}

/* Transition saat loader menghilang */
.loader-fade-leave-active {
  transition: opacity 0.4s ease, filter 0.4s ease;
}

.loader-fade-leave-to {
  opacity: 0;
  filter: blur(10px);
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
  .scan-line {
    animation: none;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0.5;
  }
  .loader-fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .loader-fade-leave-to {
    opacity: 0;
    filter: none;
  }
}
</style>
